/* TOXIC by Tendenciez — Theme JS */

// ─── HEADER SCROLL ─────────────────────────────────────
const header = document.querySelector('.site-header');
if (header) {
  const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 20);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
}

// ─── MOBILE MENU ───────────────────────────────────────
const mobileMenu = document.querySelector('.mobile-menu');
const btnOpen    = document.querySelector('.btn-menu');
const btnClose   = document.querySelector('.btn-menu-close');

if (btnOpen)  btnOpen.addEventListener('click',  () => mobileMenu?.classList.add('open'));
if (btnClose) btnClose.addEventListener('click', () => mobileMenu?.classList.remove('open'));

// ─── CART DRAWER ───────────────────────────────────────
const cartDrawer  = document.querySelector('.cart-drawer');
const cartOverlay = document.querySelector('.cart-overlay');
const btnCarts    = document.querySelectorAll('[data-open-cart]');
const btnCloseCart = document.querySelector('[data-close-cart]');

function openCart()  { cartDrawer?.classList.add('open'); cartOverlay?.classList.add('open'); }
function closeCart() { cartDrawer?.classList.remove('open'); cartOverlay?.classList.remove('open'); }

btnCarts.forEach(btn => btn.addEventListener('click', openCart));
cartOverlay?.addEventListener('click', closeCart);
btnCloseCart?.addEventListener('click', closeCart);

// ─── SUPPORT EMAIL ─────────────────────────────────────
document.querySelectorAll('.footer__email-link').forEach(link => {
  link.addEventListener('click', e => {
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || window.matchMedia('(pointer: coarse)').matches;
    if (!isMobile) {
      e.preventDefault();
      const email = link.dataset.email;
      navigator.clipboard.writeText(email).then(() => {
        const copied = link.nextElementSibling;
        if (copied) {
          copied.classList.add('visible');
          setTimeout(() => copied.classList.remove('visible'), 2000);
        }
      });
    }
  });
});

// ─── ACTIVE NAV ────────────────────────────────────────
document.querySelectorAll('.nav-links a, .mobile-menu__links a').forEach(link => {
  if (link.getAttribute('href') === window.location.pathname) {
    link.classList.add('active');
  }
});

// ─── VARIANT SELECTOR ──────────────────────────────────
document.querySelectorAll('.variant-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const group = btn.closest('.variant-btns');
    group?.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('selected'));
    btn.classList.add('selected');
    const input = document.querySelector('input[name="id"]');
    if (input) input.value = btn.dataset.variantId;
  });
});

// ─── ADD TO CART ───────────────────────────────────────
const addToCartForm = document.querySelector('.add-to-cart-form');
const cartCountEls  = document.querySelectorAll('.cart-count');

async function updateCartCount() {
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    cartCountEls.forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'grid' : 'none';
    });
    renderCartItems(cart);
  } catch (e) { console.error(e); }
}

async function renderCartItems(cart) {
  const body = document.querySelector('.cart-drawer__body');
  const total = document.querySelector('.cart-drawer__total-amount');
  if (!body) return;

  if (cart.item_count === 0) {
    body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
    if (total) total.textContent = '$0.00';
    return;
  }

  body.innerHTML = cart.items.map(item => `
    <div class="cart-item">
      <img class="cart-item__img" src="${item.image}" alt="${item.product_title}" />
      <div>
        <p class="cart-item__name">${item.product_title}</p>
        <p class="cart-item__variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</p>
      </div>
      <p class="cart-item__price">${(item.final_price / 100).toFixed(2)}</p>
    </div>
  `).join('');

  if (total) total.textContent = '$' + (cart.total_price / 100).toFixed(2);
}

addToCartForm?.addEventListener('submit', async (e) => {
  e.preventDefault();
  const formData = new FormData(addToCartForm);
  try {
    await fetch('/cart/add.js', { method: 'POST', body: formData });
    await updateCartCount();
    openCart();
  } catch (err) { console.error(err); }
});

updateCartCount();

// ─── PRODUCT CARD SWIPE GALLERIES (site-wide) ──────────
function initProductGalleries() {
  document.querySelectorAll('.product-card__gallery').forEach((g) => {
    if (g.dataset.galleryInit) return;          // guard against double-binding
    const slides = g.querySelectorAll('.product-card__slide');
    if (slides.length < 2) { g.dataset.galleryInit = '1'; return; }
    g.dataset.galleryInit = '1';

    const dots = document.createElement('div');
    dots.className = 'product-card__dots';
    slides.forEach((_, i) => {
      const d = document.createElement('span');
      d.className = 'product-card__dot' + (i === 0 ? ' is-active' : '');
      dots.appendChild(d);
    });
    g.parentNode.appendChild(dots);

    let ticking = false;
    g.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        const idx = Math.round(g.scrollLeft / g.clientWidth);
        dots.querySelectorAll('.product-card__dot').forEach((d, i) => {
          d.classList.toggle('is-active', i === idx);
        });
        ticking = false;
      });
    }, { passive: true });
  });
}
initProductGalleries();
